<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    import type { PendingWakeup } from 'models'

    /**
     * The check the agent will run by itself next (spec agent-wakeup): when,
     * why, and the user's way to stop it. Above the input, because it is the
     * one thing in the chat still to happen.
     */
    defineProps<{
        pending: PendingWakeup
        stopping?: boolean
    }>()

    const emit = defineEmits<{
        stop: []
    }>()

    const { t: $t, d: $d } = useI18n({ useScope: 'global' })
</script>

<template>
    <div class="pk-chatbot-wakeup-bar" role="status">
        <VvIcon name="ri:alarm-line" class="shrink-0" />
        <span class="pk-chatbot-wakeup-bar__text">
            <strong>
                {{
                    $t('label.wakeupNext', {
                        time: $d(new Date(pending.dueAt), 'time'),
                    })
                }}
            </strong>
            <span class="pk-chatbot-wakeup-bar__reason">
                {{ pending.reason }}
            </span>
        </span>
        <VvButton
            :label="$t('action.stop')"
            modifiers="action-quiet"
            :loading="stopping"
            :disabled="stopping"
            @click="emit('stop')" />
    </div>
</template>

<style lang="scss">
    .pk-chatbot-wakeup-bar {
        display: flex;
        align-items: center;
        gap: var(--spacing-sm);
        padding: var(--spacing-xs) var(--spacing-md);
        border-top: 1px solid var(--color-surface-3);
        color: var(--color-word-3);
        font-size: var(--text-12);

        &__text {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;
        }

        &__reason {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
</style>
